import { Component, Input, OnInit, OnDestroy, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { AddInstituteService } from '../../../../services/super-admin/add-institute.service';
import { scrollToFirstInvalidControl } from '../../../../direct-apply/shared/validators/form-validation.utils';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { FileUploadModule } from 'primeng/fileupload';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { AccordionModule } from 'primeng/accordion';
import { ChipModule } from 'primeng/chip';
import { GoogleMapsModule } from '@angular/google-maps';
import { DialogModule } from 'primeng/dialog';
import { TooltipModule } from 'primeng/tooltip';
import Cropper from 'cropperjs';
import { StateResponse } from '../../../../models/Institutedetails/Stateresponse';
import { apiResponse } from '../../../../models/apiResponse';
import { DropdownChangeEvent } from 'primeng/dropdown';
import { countryResponse } from '../../../../models/Institutedetails/Countryresponse';
import { CityRequest, CityResponse } from '../../../../models/Institutedetails/CityResponse';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { Subscription } from 'rxjs';
import { of } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, map, catchError } from 'rxjs/operators';
import { CheckboxModule } from 'primeng/checkbox';
import { TableModule } from 'primeng/table';

@Component({
    selector: 'app-basic-info',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        InputTextModule,
        DropdownModule,
        InputTextareaModule,
        FileUploadModule,
        ButtonModule,
        DividerModule,
        AccordionModule,
        ChipModule,
        GoogleMapsModule,
        DialogModule,
        ToastModule,
        ProgressSpinnerModule,
        TooltipModule,
        CheckboxModule,
        TableModule
    ],
    providers: [MessageService],
    templateUrl: './basic-info.component.html',
    styleUrls: ['./basic-info.component.scss']
})
export class BasicInfoComponent implements OnInit, OnDestroy {
    @Input() form!: FormGroup;
    @Input() instituteId: string | null = null;
    @Input() isEditMode: boolean = false;
    @Input() branchCampusesData: string[] = [];
    @Input() alumniData: any = null;
    @Output() onSaveSuccess = new EventEmitter<any>();
    @Output() onSaveError = new EventEmitter<any>();
    @ViewChild('logoInput') logoInput!: ElementRef;
    @ViewChild('bannerInput') bannerInput!: ElementRef;
    @ViewChild('cropperImage') cropperImage!: ElementRef<HTMLImageElement>;
    cropper: Cropper | null = null;
    displayCropper: boolean = false;
    isSaving: boolean = false;
    currentCropType: 'logo' | 'banner' | 'alumni' | null = null;
    imageToCrop: string | null = null;
    newCampusName: string = '';
    logoPreview: string | null = null;
    bannerPreview: string | null = null;
    loadder: boolean = false;
    cropperActionType: 'save' | 'cancel' | null = null;
    center: google.maps.LatLngLiteral = { lat: 0, lng: 0 };
    zoom = 12;
    isInfluentialAlumniOpen: boolean = false;
    // isAlumniInLeadershipRolesOpen: boolean = false;
    // isStartupFoundersFromCollegeOpen: boolean = false;


    showAlumniDialog: boolean = false;
    currentAlumniCategory: 'influential' | 'leadership' | 'startup' | null = null;
    currentAlumniEntry: any = {
        firstName: '',
        lastName: '',
        designation: '',
        image: null,
        imagePreview: null
    };
    isEditingAlumni: boolean = false;
    editingAlumniIndex: number | null = null;

    alumniCategories = [
        { label: 'Influential Alumni', type: 'influential' },
        // { label: 'Alumni in Leadership Roles', type: 'leadership' },
        // { label: 'Startup Founders from College', type: 'startup' }
    ];

    countries: countryResponse[] = [];
    provinces: StateResponse[] = [];
    cities: CityResponse[] = [];
    loading: boolean = false;
    savingCrop: boolean = false;
    cancellingCrop: boolean = false;
    private nameCheckSubscription: Subscription | null = null;
    initialInstituteName: string | null = null;
    private nameCheckInitialized = false;


    showAddProvinceDialog: boolean = false;
    savingProvince: boolean = false;
    provinceSubmitted: boolean = false;
    selectedCountryName: string = '';
    newProvince: { name: string; code: string; countryId: number } = { name: '', code: '', countryId: 0 };


    showAddCityDialog: boolean = false;
    savingCity: boolean = false;
    citySubmitted: boolean = false;
    selectedProvinceName: string = '';
    newCity: CityRequest = { name: '', provinceId: 0 };
    instituteTypes = [
        { label: 'University', value: 'University' },
        { label: 'College', value: 'College' },
        { label: 'Vocational', value: 'Vocational' },
        { label: 'Other', value: 'Other' }
    ];

    controlTypes = [
        { label: 'Public', value: 'Public' },
        { label: 'Private', value: 'Private' },
        { label: 'Government', value: 'Government' }
    ];

    urbanizationLevels = [
        { label: 'City', value: 'City' },
        { label: 'Suburb', value: 'Suburb' },
        { label: 'Urban', value: 'Urban' },
        { label: 'Town', value: 'Town' },
        { label: 'Rural', value: 'Rural' },
        { label: 'Semiurban', value: 'Semiurban' },
        { label: 'Suburban', value: 'Suburban' }
    ];

    constructor(
        private fb: FormBuilder,
        private instituteservices: AddInstituteService,
        private messageService: MessageService

    ) { }

    ngOnChanges(changes: import('@angular/core').SimpleChanges) {
        if (changes['branchCampusesData']) {
            this.updateBranchCampuses();
        }
        if (changes['alumniData']) {
            this.updateAlumniData();
        }
    }

    private updateAlumniData() {
        if (!this.form || !this.alumniData) return;

        this.isInfluentialAlumniOpen = this.alumniData.hasInfluentialAlumni ?? false;
        // this.isAlumniInLeadershipRolesOpen = this.alumniData.hasAlumniInLeadershipRoles ?? false;
        // this.isStartupFoundersFromCollegeOpen = this.alumniData.hasStartupFoundersFromCollege ?? false;

        this.patchAlumniArray(this.influentialAlumniList, this.alumniData.influentialAlumni);
        // this.patchAlumniArray(this.alumniInLeadershipRolesList, this.alumniData.alumniInLeadershipRoles);
        // this.patchAlumniArray(this.startupFoundersFromCollegeList, this.alumniData.startupFoundersFromCollege);

        this.form.patchValue({
            influentialAlumni: this.isInfluentialAlumniOpen,
            // alumniInLeadershipRoles: this.isAlumniInLeadershipRolesOpen,
            // startupFoundersFromCollege: this.isStartupFoundersFromCollegeOpen
        }, { emitEvent: false });
    }

    private patchAlumniArray(array: FormArray, data: any[]) {
        if (!array) return;
        while (array.length !== 0) {
            array.removeAt(0);
        }
        if (data && Array.isArray(data)) {
            data.forEach(item => {
                array.push(this.fb.group({
                    firstName: [item.firstName],
                    lastName: [item.lastName],
                    designation: [item.designation],
                    image: [null],
                    imagePreview: [item.profileImage || item.imagePreview || null]
                }));
            });
        }
    }

    openAddAlumniDialog(category: string) {
        this.currentAlumniCategory = category as any;
        this.currentAlumniEntry = { firstName: '', lastName: '', designation: '', image: null, imagePreview: null };
        this.isEditingAlumni = false;
        this.editingAlumniIndex = null;
        this.showAlumniDialog = true;
    }

    editAlumniEntry(category: string, index: number) {
        this.currentAlumniCategory = category as any;
        const listName = this.getListNameByCategory(category);
        const array = this.form.get(listName) as FormArray;
        const entry = array.at(index).value;

        this.currentAlumniEntry = { ...entry };
        this.isEditingAlumni = true;
        this.editingAlumniIndex = index;
        this.showAlumniDialog = true;
    }


    onAlumniFileSelect(event: any) {
        const file = event.target.files[0];
        if (file) {
            this.loading = true;
            const reader = new FileReader();
            reader.onload = (e: any) => {
                this.imageToCrop = e.target.result;
                this.currentCropType = 'alumni';
                this.displayCropper = true;
                this.loading = false;
            };
            reader.readAsDataURL(file);
            event.target.value = '';
        }
    }

    saveAlumniEntry() {
        if (!this.currentAlumniEntry.firstName) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'First name is required.' });
            return;
        }

        const listName = this.getListNameByCategory(this.currentAlumniCategory!);
        const array = this.form.get(listName) as FormArray;

        const entryValue = {
            firstName: this.currentAlumniEntry.firstName,
            lastName: this.currentAlumniEntry.lastName,
            designation: this.currentAlumniEntry.designation,
            image: this.currentAlumniEntry.image,
            imagePreview: this.currentAlumniEntry.imagePreview
        };



        if (this.isEditingAlumni && this.editingAlumniIndex !== null) {
            array.at(this.editingAlumniIndex).patchValue(entryValue);
        } else {
            array.push(this.fb.group({
                firstName: [entryValue.firstName],
                lastName: [entryValue.lastName],
                designation: [entryValue.designation],
                image: [entryValue.image],
                imagePreview: [entryValue.imagePreview]
            }));
        }

        this.showAlumniDialog = false;
    }

    removeAlumniEntry(category: string, index: number) {
        const listName = this.getListNameByCategory(category);
        const array = this.form.get(listName) as FormArray;
        array.removeAt(index);
    }

    getListNameByCategory(category: string): string {
        switch (category) {
            case 'influential': return 'influentialAlumniList';
            case 'leadership': return 'alumniInLeadershipRolesList';
            case 'startup': return 'startupFoundersFromCollegeList';
            default: return '';
        }
    }

    getCheckboxControlName(type: string): string {
        switch (type) {
            case 'influential': return 'influentialAlumni';
            case 'leadership': return 'alumniInLeadershipRoles';
            case 'startup': return 'startupFoundersFromCollege';
            default: return '';
        }
    }

    getCategoryLabel(type: string): string {
        return this.alumniCategories.find(c => c.type === type)?.label || 'Alumni';
    }

    private updateBranchCampuses() {
        if (this.form) {
            const array = this.form.get('branchCampusNames') as FormArray;
            if (array && this.branchCampusesData) {
                while (array.length !== 0) {
                    array.removeAt(0);
                }
                this.branchCampusesData.forEach(name => {
                    array.push(this.fb.control(name));
                });
                this.form.get('branchCampuses')?.setValue(array.length > 0 ? array.length : null);
            }
        }
    }

    ngOnInit() {
        if (this.form) {
            this.form.addControl('name', this.fb.control('', [Validators.required]));
            this.form.addControl('missionStatement', this.fb.control(''));
            this.form.addControl('webSite', this.fb.control(''));

            this.form.addControl('address', this.fb.control(''));
            this.form.addControl('countryId', this.fb.control(''));
            this.form.addControl('countryCode', this.fb.control(''));
            this.form.addControl('provinceId', this.fb.control(null));
            this.form.addControl('cityId', this.fb.control(null));
            this.form.addControl('controlOfInstitution', this.fb.control(''));
            this.form.addControl('branchCampuses', this.fb.control(''));

            this.form.addControl('branchCampusNames', this.fb.array([]));

            this.form.addControl('latitude', this.fb.control(''));
            this.form.addControl('longitude', this.fb.control(''));
            this.form.addControl('yearOfEstablishment', this.fb.control(''));
            this.form.addControl('instituteOrCollageType', this.fb.control(''));
            this.form.addControl('instituteCode', this.fb.control('', [Validators.required]));

            this.form.addControl('logo', this.fb.control(''));
            this.form.addControl('image', this.fb.control(''));
            this.form.addControl('degreeOfUrbanization', this.fb.control(''));
            this.form.addControl('netPriceCalculator', this.fb.control(''));
            this.form.addControl('sportsFacilities', this.fb.control(false));
            this.form.addControl('swimmingPool', this.fb.control(false));
            this.form.addControl('gym', this.fb.control(false));
            this.form.addControl('culturalFestivals', this.fb.control(false));
            this.form.addControl('techFests', this.fb.control(false));
            this.form.addControl('collegeFests', this.fb.control(false));
            this.form.addControl('clubsAndSocieties', this.fb.control(false));
            this.form.addControl('tech', this.fb.control(false));
            this.form.addControl('arts', this.fb.control(false));
            this.form.addControl('entrepreneurship', this.fb.control(false));
            this.form.addControl('labAndResearchCentres', this.fb.control(false));
            this.form.addControl('fundingForStudentProjects', this.fb.control(false));
            this.form.addControl('publicationsPerYear', this.fb.control(''));
            this.form.addControl('influentialAlumni', this.fb.control(false));
            this.form.addControl('alumniInLeadershipRoles', this.fb.control(false));
            this.form.addControl('startupFoundersFromCollege', this.fb.control(false));
            this.form.addControl('influentialAlumniList', this.fb.array([]));
            this.form.addControl('alumniInLeadershipRolesList', this.fb.array([]));
            this.form.addControl('startupFoundersFromCollegeList', this.fb.array([]));
            this.form.addControl('chill', this.fb.control(false));
            this.form.addControl('competitive', this.fb.control(false));
            this.form.addControl('startup', this.fb.control(false));
            this.form.addControl('research', this.fb.control(false));
            this.form.addControl('creative', this.fb.control(false));
            this.form.addControl('traditional', this.fb.control(false));
            this.loadCountries();

            this.form.valueChanges
                .pipe(
                    debounceTime(500),
                    distinctUntilChanged((prev, curr) => prev.latitude === curr.latitude && prev.longitude === curr.longitude)
                )
                .subscribe(value => {
                    const latStr = value.latitude;
                    const lngStr = value.longitude;

                    if (latStr && lngStr) {
                        const lat = parseFloat(latStr);
                        const lng = parseFloat(lngStr);

                        if (!isNaN(lat) && !isNaN(lng) && lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180) {
                            this.center = { lat, lng };
                            this.zoom = 15;
                            if (this.form.dirty) {
                                this.messageService.add({ severity: 'success', summary: 'Location Updated', detail: 'Map location updated successfully' });
                            }
                        } else {
                            if (this.form.dirty) {
                                this.messageService.add({ severity: 'error', summary: 'Invalid Coordinates', detail: 'plz enter correct cordinates' });
                            }
                        }
                    }
                });

            this.form.get('countryCode')?.valueChanges.subscribe(countryCode => {
                if (countryCode) {
                    this.loadProvinces(countryCode);
                    const country = this.countries.find(country => country.countryCode === countryCode);
                    if (country) {
                        this.form.get('countryId')?.setValue(country.id, { emitEvent: false });
                    }
                } else {
                    this.form.get('countryId')?.setValue(null, { emitEvent: false });
                    this.provinces = [];
                    this.form.get('provinceId')?.setValue(null);
                }
            });

            this.form.get('provinceId')?.valueChanges.subscribe(provinceId => {
                if (provinceId) {
                    this.loadCities(provinceId);
                } else {
                    this.cities = [];
                    this.form.get('cityId')?.setValue(null);
                }
            });

            const initialLogo = this.form.get('logo')?.value;
            if (typeof initialLogo === 'string' && initialLogo) {
                this.logoPreview = initialLogo;
            }
            const initialImage = this.form.get('image')?.value;
            if (typeof initialImage === 'string' && initialImage) {
                this.bannerPreview = initialImage;
            }

            this.form.get('logo')?.valueChanges.subscribe(val => {
                if (typeof val === 'string' && val) this.logoPreview = val;
            });
            this.form.get('image')?.valueChanges.subscribe(val => {
                if (typeof val === 'string' && val) this.bannerPreview = val;
            });

            this.setupInstituteNameExistsCheck();
            this.updateBranchCampuses();
        }
    }

    private setupInstituteNameExistsCheck(): void {
        const nameControl = this.form.get('name');
        if (!nameControl) return;

        this.nameCheckSubscription = nameControl.valueChanges
            .pipe(
                debounceTime(400),
                distinctUntilChanged(),
                switchMap((name: string) => {
                    const n = (name ?? '').trim();
                    if (n.length < 2) {
                        this.clearInstituteNameExistsError();
                        return of(null);
                    }
                    if (this.isEditMode && !this.nameCheckInitialized) {
                        this.initialInstituteName = n || this.initialInstituteName;
                        this.nameCheckInitialized = true;
                    }
                    if (this.isEditMode && this.initialInstituteName && n.toLowerCase() === this.initialInstituteName.trim().toLowerCase()) {
                        this.clearInstituteNameExistsError();
                        return of(null);
                    }
                    return this.instituteservices.checkInstituteNameExists(name).pipe(
                        map((exists) => ({ name: n, exists })),
                        catchError(() => of({ name: n, exists: false }))
                    );
                })
            )
            .subscribe((result) => {
                if (result == null) return;
                const control = this.form.get('name');
                if (!control) return;
                if (result.exists) {
                    control.setErrors({ ...control.errors, instituteNameExists: true });
                } else {
                    this.clearInstituteNameExistsError();
                }
            });
    }

    private clearInstituteNameExistsError(): void {
        const nameControl = this.form.get('name');
        if (!nameControl?.errors) return;
        const err = { ...nameControl.errors };
        delete (err as Record<string, unknown>)['instituteNameExists'];
        nameControl.setErrors(Object.keys(err).length > 0 ? err : null);
    }

    ngOnDestroy(): void {
        this.nameCheckSubscription?.unsubscribe();
        this.nameCheckSubscription = null;
    }

    private loadCountries() {
        this.instituteservices.getCountry().subscribe({
            next: (response: apiResponse<countryResponse[]>) => {
                this.countries = response.result || [];
                const currentCountryCode = this.form.get('countryCode')?.value;
                if (currentCountryCode) {
                    const country = this.countries.find(c => c.countryCode === currentCountryCode);
                    if (country) {
                        this.form.get('countryId')?.setValue(country.id, { emitEvent: false });
                    }
                    this.loadProvinces(currentCountryCode);
                }
            },
            error: (err: any) => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load countries' });
            }
        });
    }

    private loadProvinces(countrycode: string) {
        this.instituteservices.getProvinces(countrycode).subscribe({
            next: (response: apiResponse<StateResponse[]>) => this.provinces = response.result || [],
            error: (err: any) => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load provinces' });
            }
        });
    }

    private loadCities(provinceId: number) {
        this.instituteservices.getCity(provinceId).subscribe({
            next: (response: apiResponse<CityResponse[]>) => this.cities = response.result || [],
            error: (err: any) => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load cities' });
            }
        });
    }

    get branchCampusNames(): FormArray {
        return this.form.get('branchCampusNames') as FormArray;
    }

    get influentialAlumniList(): FormArray {
        return this.form.get('influentialAlumniList') as FormArray;
    }

    // get alumniInLeadershipRolesList(): FormArray {
    //     return this.form.get('alumniInLeadershipRolesList') as FormArray;
    // }

    // get startupFoundersFromCollegeList(): FormArray {
    //     return this.form.get('startupFoundersFromCollegeList') as FormArray;
    // }

    toggleAlumniSection(type: string) {
        if (type === 'influential') {
            this.isInfluentialAlumniOpen = !this.isInfluentialAlumniOpen;
            this.form.get('influentialAlumni')?.setValue(this.isInfluentialAlumniOpen);
        } 
        // else if (type === 'leadership') {
        //     this.isAlumniInLeadershipRolesOpen = !this.isAlumniInLeadershipRolesOpen;
        //     this.form.get('alumniInLeadershipRoles')?.setValue(this.isAlumniInLeadershipRolesOpen);
        // } else if (type === 'startup') {
        //     this.isStartupFoundersFromCollegeOpen = !this.isStartupFoundersFromCollegeOpen;
        //     this.form.get('startupFoundersFromCollege')?.setValue(this.isStartupFoundersFromCollegeOpen);
        // }
    }

    openAddProvinceDialog() {
        const countryId = this.form.get('countryId')?.value;
        const countryCode = this.form.get('countryCode')?.value;
        if (!countryCode) {
            this.messageService.add({ severity: 'warn', summary: 'Select Country', detail: 'Please select a country first.' });
            return;
        }
        const country = this.countries.find(c => c.countryCode === countryCode);
        this.selectedCountryName = country?.name ?? '';
        this.newProvince = { name: '', code: '', countryId: countryId || 0 };
        this.provinceSubmitted = false;
        this.showAddProvinceDialog = true;
    }

    closeAddProvinceDialog() {
        this.showAddProvinceDialog = false;
        this.provinceSubmitted = false;
        this.newProvince = { name: '', code: '', countryId: 0 };
    }

    saveNewProvince() {
        this.provinceSubmitted = true;
        if (!this.newProvince.name?.trim() || !this.newProvince.code?.trim()) {
            return;
        }
        this.savingProvince = true;
        const payload = {
            name: this.newProvince.name.trim(),
            code: this.newProvince.code.trim().toUpperCase(),
            countryId: this.newProvince.countryId
        };
        this.instituteservices.addProvince(payload).subscribe({
            next: (res: any) => {
                this.savingProvince = false;
                this.messageService.add({ severity: 'success', summary: 'Province Added', detail: `"${payload.name}" has been added successfully.` });
                const countryCode = this.form.get('countryCode')?.value;
                if (countryCode) {
                    this.loadProvinces(countryCode);
                }

                const newId = res?.result?.id || res?.id;
                if (newId) {
                    setTimeout(() => {
                        this.form.get('provinceId')?.setValue(newId);
                    }, 600);
                }
                this.closeAddProvinceDialog();
            },
            error: (err: any) => {
                this.savingProvince = false;
                const msg = err?.error?.message || 'Failed to add province. Please try again.';
                this.messageService.add({ severity: 'error', summary: 'Error', detail: msg });
            }
        });
    }

    openAddCityDialog() {
        const provinceId = this.form.get('provinceId')?.value;
        if (!provinceId) {
            this.messageService.add({ severity: 'warn', summary: 'Select Province', detail: 'Please select a province first.' });
            return;
        }
        const province = this.provinces.find(p => p.id === provinceId);
        this.selectedProvinceName = province?.name ?? '';
        this.newCity = { name: '', provinceId: provinceId };
        this.citySubmitted = false;
        this.showAddCityDialog = true;
    }

    closeAddCityDialog() {
        this.showAddCityDialog = false;
        this.citySubmitted = false;
        this.newCity = { name: '', provinceId: 0 };
    }

    saveNewCity() {
        this.citySubmitted = true;
        if (!this.newCity.name?.trim()) {
            return;
        }
        this.savingCity = true;
        const payload: CityRequest = {
            name: this.newCity.name.trim(),
            provinceId: this.newCity.provinceId
        };
        this.instituteservices.addCity(payload).subscribe({
            next: (res: any) => {
                this.savingCity = false;
                this.messageService.add({ severity: 'success', summary: 'City Added', detail: `"${payload.name}" has been added successfully.` });
                const provinceId = this.form.get('provinceId')?.value;
                if (provinceId) {
                    this.loadCities(provinceId);
                }

                const newId = res?.result?.id || res?.id;
                if (newId) {
                    setTimeout(() => {
                        this.form.get('cityId')?.setValue(newId);
                    }, 600);
                }
                this.closeAddCityDialog();
            },
            error: (err: any) => {
                this.savingCity = false;
                const msg = err?.error?.message || 'Failed to add city. Please try again.';
                this.messageService.add({ severity: 'error', summary: 'Error', detail: msg });
            }
        });
    }

    addCampus() {
        if (this.newCampusName.trim()) {
            this.branchCampusNames.push(this.fb.control(this.newCampusName.trim()));
            this.newCampusName = '';
            this.form.get('branchCampuses')?.setValue(this.branchCampusNames.length > 0 ? this.branchCampusNames.length : null);
        } else if (this.branchCampusNames.length === 0) {
            this.branchCampusNames.markAsTouched();
        }
    }


    removeCampus(index: number) {
        this.branchCampusNames.removeAt(index);
        this.form.get('branchCampuses')?.setValue(this.branchCampusNames.length > 0 ? this.branchCampusNames.length : null);
    }


    triggerUpload(type: 'logo' | 'banner') {
        if (type === 'logo') this.logoInput.nativeElement.click();
        else this.bannerInput.nativeElement.click();
    }

    onFileSelect(event: any, type: 'logo' | 'banner') {
        if (type === 'logo') {
            this.onLogoSelect(event);
        } else {
            this.onBannerSelect(event);
        }
    }

    onLogoSelect(event: any) {
        const file = event.target.files[0];
        if (file) {
            this.loading = true;
            const reader = new FileReader();
            reader.onload = (e: any) => {
                this.imageToCrop = e.target.result;
                this.currentCropType = 'logo';
                this.displayCropper = true;
                this.logoInput.nativeElement.value = '';
                this.loading = false;
            };
            reader.readAsDataURL(file);
        }
    }

    onBannerSelect(event: any) {
        const file = event.target.files[0];
        if (file) {
            this.loading = true;
            const reader = new FileReader();
            reader.onload = (e: any) => {
                this.imageToCrop = e.target.result;
                this.currentCropType = 'banner';
                this.displayCropper = true;
                this.bannerInput.nativeElement.value = '';
                this.loading = false;
            };
            reader.readAsDataURL(file);
        }
    }

    initCropper() {
        if (this.currentCropType === 'logo') {
            this.initLogoCropper();
        } else if (this.currentCropType === 'banner') {
            this.initBannerCropper();
        } else if (this.currentCropType === 'alumni') {
            this.initAlumniCropper();
        }
    }

    initLogoCropper() {
        if (this.cropper) {
            this.cropper.destroy();
        }
        this.cropper = new Cropper(this.cropperImage.nativeElement, {
            aspectRatio: 1,
            viewMode: 1,
            guides: true,
            center: true,
            highlight: false,
            cropBoxMovable: true,
            cropBoxResizable: true,
            autoCropArea: 0.8
        });
    }

    initBannerCropper() {
        if (this.cropper) {
            this.cropper.destroy();
        }
        this.cropper = new Cropper(this.cropperImage.nativeElement, {
            aspectRatio: 16 / 9,
            viewMode: 1,
            guides: true,
            center: true,
            highlight: false,
            cropBoxMovable: true,
            cropBoxResizable: true,
            autoCropArea: 1
        });
    }

    initAlumniCropper() {
        if (this.cropper) {
            this.cropper.destroy();
        }
        this.cropper = new Cropper(this.cropperImage.nativeElement, {
            aspectRatio: 1,
            viewMode: 1,
            guides: true,
            center: true,
            highlight: false,
            cropBoxMovable: true,
            cropBoxResizable: true,
            autoCropArea: 0.8
        });
    }

    saveCrop() {
        this.loadder = true;
        this.cropperActionType = 'save';
        if (this.currentCropType === 'logo') {
            this.saveLogoCrop();
        } else if (this.currentCropType === 'banner') {
            this.saveBannerCrop();
        } else if (this.currentCropType === 'alumni') {
            this.saveAlumniCrop();
        }
    }

    saveLogoCrop() {
        if (this.cropper) {
            this.savingCrop = true;
            const canvas = this.cropper.getCroppedCanvas({
                width: 400,
                height: 400
            });

            canvas.toBlob((blob) => {
                if (blob) {
                    const croppedFile = new File([blob], 'logo.jpg', { type: 'image/jpeg' });
                    const reader = new FileReader();
                    reader.onload = () => {
                        this.logoPreview = reader.result as string;
                        this.form.get('logo')?.setValue(croppedFile);
                        this.cropperActionType = 'save';
                        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Image saved successfully' });
                        this.isSaving = false;
                        this.displayCropper = false;
                        this.savingCrop = false;
                        this.loadder = false;
                    };
                    reader.readAsDataURL(croppedFile);
                } else {
                    this.savingCrop = false;
                    this.loadder = false;
                    this.cropperActionType = null;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to crop logo' });
                }
            }, 'image/jpeg');
        } else {
            this.savingCrop = false;
            this.loadder = false;
            this.cropperActionType = null;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to crop logo' });
        }
    }

    saveBannerCrop() {
        if (this.cropper) {
            this.savingCrop = true;
            const canvas = this.cropper.getCroppedCanvas({
                width: 1920,
                height: 1080
            });

            canvas.toBlob((blob) => {
                if (blob) {
                    const croppedFile = new File([blob], 'banner.jpg', { type: 'image/jpeg' });
                    const reader = new FileReader();
                    reader.onload = () => {
                        this.bannerPreview = reader.result as string;
                        this.form.get('image')?.setValue(croppedFile);
                        this.cropperActionType = 'save';
                        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Image saved successfully' });
                        this.isSaving = false;
                        this.displayCropper = false;
                        this.savingCrop = false;
                        this.loadder = false;
                    };
                    reader.readAsDataURL(croppedFile);
                } else {
                    this.savingCrop = false;
                    this.loadder = false;
                    this.cropperActionType = null;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to crop banner' });
                }
            }, 'image/jpeg');
        } else {
            this.savingCrop = false;
            this.loadder = false;
            this.cropperActionType = null;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to crop banner' });
        }
    }

    saveAlumniCrop() {
        if (this.cropper) {
            this.savingCrop = true;
            const canvas = this.cropper.getCroppedCanvas({
                width: 100,
                height: 100
            });

            canvas.toBlob((blob) => {
                if (blob) {
                    const croppedFile = new File([blob], 'alumni.jpg', { type: 'image/jpeg' });
                    const reader = new FileReader();
                    reader.onload = () => {
                        this.currentAlumniEntry.imagePreview = reader.result as string;
                        this.currentAlumniEntry.image = croppedFile;
                        this.cropperActionType = 'save';
                        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Alumni photo cropped successfully' });
                        this.displayCropper = false;
                        this.savingCrop = false;
                        this.loadder = false;
                    };
                    reader.readAsDataURL(croppedFile);
                } else {
                    this.savingCrop = false;
                    this.loadder = false;
                    this.cropperActionType = null;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to crop alumni photo' });
                }
            }, 'image/jpeg');
        } else {
            this.savingCrop = false;
            this.loadder = false;
            this.cropperActionType = null;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to crop alumni photo' });
        }
    }

    closeCropper() {
        this.loadder = true;
        this.cancellingCrop = true;
        this.cropperActionType = 'cancel';

        setTimeout(() => {
            this.messageService.add({
                severity: 'warn',
                summary: 'Cancelled',
                detail: 'Crop image didn\'t save'
            });
            this.displayCropper = false;
            this.loadder = false;
        }, 500);
    }

    onDialogHide() {
        setTimeout(() => {
            this.imageToCrop = null;
            this.currentCropType = null;
            if (this.cropper) {
                this.cropper.destroy();
                this.cropper = null;
            }
            this.isSaving = false;
            this.savingCrop = false;
            this.cancellingCrop = false;
            this.cropperActionType = null;
        }, 300);
    }

    removeFile(type: 'logo' | 'banner', event: Event) {
        event.stopPropagation();
        this.loading = true;

        setTimeout(() => {
            if (type === 'logo') {
                this.logoPreview = null;
                this.form.get('logo')?.setValue(null);
                this.logoInput.nativeElement.value = '';
                this.messageService.add({
                    severity: 'success',
                    summary: 'Deleted',
                    detail: 'Image removed successfully'
                });
            } else {
                this.bannerPreview = null;
                this.form.get('image')?.setValue(null);
                this.bannerInput.nativeElement.value = '';
                this.messageService.add({
                    severity: 'success',
                    summary: 'Deleted',
                    detail: 'Image removed successfully'
                });
            }
            this.loading = false;
        }, 500);
    }

    save() {
        if (this.form.valid) {
            const formData = new FormData();
            const formValue = this.form.value;
            formData.append('Name', formValue.name || '');
            formData.append('InstituteCode', formValue.instituteCode || '');
            formData.append('YearOfEstablishment', formValue.yearOfEstablishment || '');
            formData.append('InstituteOrCollageType', formValue.instituteOrCollageType || '');
            formData.append('ControlOfInstitution', formValue.controlOfInstitution || '');
            formData.append('BranchCampuses', (formValue.branchCampuses || '').toString());
            formData.append('MissionStatement', formValue.missionStatement || '');
            formData.append('WebSite', formValue.webSite || '');
            if (formValue.cityId) {
                formData.append('CityId', formValue.cityId.toString());
            }
            if (formValue.provinceId) {
                formData.append('provinceId', formValue.provinceId.toString());
            }
            if (formValue.countryId) {
                formData.append('CountryId', formValue.countryId.toString());
            }
            formData.append('DegreeOfUrbanization', formValue.degreeOfUrbanization || '');
            formData.append('Address', formValue.address || '');
            formData.append('Latitude', formValue.latitude || '');
            formData.append('Longitude', formValue.longitude || '');
            const facilities = {
                SportsFacilities: formValue.sportsFacilities,
                SwimmingPool: formValue.swimmingPool,
                Gym: formValue.gym
            };
            formData.append('Facilities', JSON.stringify(facilities));

            const instituteActivities = {
                CulturalFestivals: formValue.culturalFestivals,
                TechFests: formValue.techFests,
                CollegeFests: formValue.collegeFests,
                ClubsAndSocieties: formValue.clubsAndSocieties,
                Tech: formValue.tech,
                Arts: formValue.arts
            };
            formData.append('InstituteActivities', JSON.stringify(instituteActivities));

            const researchFacilities = {
                Entrepreneurship: formValue.entrepreneurship,
                LabAndResearchCentres: formValue.labAndResearchCentres,
                FundingForStudentProjects: formValue.fundingForStudentProjects,
                PublicationsPerYear: formValue.publicationsPerYear || 0
            };
            formData.append('ResearchFacilities', JSON.stringify(researchFacilities));

            const formatAlumni = (list: any[]) => {
                return (list || []).map(item => ({
                    firstName: item.firstName,
                    lastName: item.lastName,
                    designation: item.designation || '',
                    profileImage: item.imagePreview || ''
                }));
            };

            const alumni = {
                HasInfluentialAlumni: formValue.influentialAlumni,
                InfluentialAlumni: formatAlumni(formValue.influentialAlumniList),
                HasAlumniInLeadershipRoles: formValue.alumniInLeadershipRoles,
                AlumniInLeadershipRoles: formatAlumni(formValue.alumniInLeadershipRolesList),
                HasStartupFoundersFromCollege: formValue.startupFoundersFromCollege,
                StartupFoundersFromCollege: formatAlumni(formValue.startupFoundersFromCollegeList)
            };
            formData.append('Alumni', JSON.stringify(alumni));

            if (formValue.branchCampusNames && Array.isArray(formValue.branchCampusNames)) {
                formValue.branchCampusNames.forEach((name: string) => {
                    formData.append('NameOfBranchCampuses', name);
                });
            }

            if (formValue.logo instanceof File) {
                formData.append('Logo', formValue.logo);
            }
            if (formValue.image instanceof File) {
                formData.append('Image', formValue.image);
            }
            if (formValue.netPriceCalculator) {
                formData.append('NetPriceCalculator', formValue.netPriceCalculator);
            }

            if (this.isSaving) return;
            this.isSaving = true;

            if (this.instituteId) {
                formData.append('Id', this.instituteId);
                this.instituteservices.updateBasicDetails(this.instituteId, formData).subscribe({
                    next: (res: any) => {
                        this.isSaving = false;
                        this.onSaveSuccess.emit({ mode: 'edit', response: res });
                    },
                    error: (err: any) => {
                        this.isSaving = false;
                        this.onSaveError.emit(err);
                    }
                });
            } else {
                this.instituteservices.basicdetails(formData).subscribe({
                    next: (res: any) => {
                        this.isSaving = false;
                        const data = res.result || res;
                        const newId = data.instituteId || data.Id || data.id;
                        if (newId) {
                            this.instituteId = String(newId);
                        }
                        this.onSaveSuccess.emit({ mode: 'add', response: res });
                    },
                    error: (err: any) => {
                        this.isSaving = false;
                        this.onSaveError.emit(err);
                    }
                });
            }
        } else {
            this.markFormGroupTouched(this.form);
            scrollToFirstInvalidControl();
            const invalidFields = this.getInvalidFields();
            this.onSaveError.emit({ validationError: true, fields: invalidFields });
        }
    }

    private getInvalidFields(): string[] {
        const invalid: string[] = [];
        const controls = this.form.controls;
        for (const name in controls) {
            if (controls[name].invalid) {
                const label = name
                    .replace(/([A-Z])/g, ' $1')
                    .replace(/^./, (str) => str.toUpperCase());
                invalid.push(label);
            }
        }
        return invalid;
    }

    private markFormGroupTouched(formGroup: FormGroup | FormArray) {
        formGroup.markAsTouched();
        Object.values(formGroup.controls).forEach(control => {
            if (control instanceof FormGroup || control instanceof FormArray) {
                this.markFormGroupTouched(control);
            } else {
                control.markAsTouched();
                control.markAsDirty();
            }
        });
    }
}
